import React, { useState } from 'react';
import styled from '../../../../../styled';
import Dropdown from '../../../../dropdown/Dropdown';
const DropdownWrapper = styled.div `
  margin-bottom: 0.25rem;
`;
const PrivateDropdown = ({ value, options, onChange, placeHolder, }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(DropdownWrapper, null,
        React.createElement(Dropdown, { options: options, isOpen: isOpen, onClose: () => setIsOpen(false), onClick: () => setIsOpen(true), onChange: onChange, value: value, menuAlign: "left", width: "11rem", placeHolder: placeHolder, placeHolderColor: "INK_400" })));
};
export default React.memo(PrivateDropdown);
//# sourceMappingURL=ItemPrivateDropdown.js.map